import { Users } from '../../../server/dto/generated/Users';


import { GeneratedBizBase } from '../../../framework/frontend/GeneratedBizBase';


import { Response } from '../../../framework/biz/Response';


 // サーバーサイドコードへのリンク(このコードは実行されません)
const __non_exec_code = async () => {
  // import("../../../server/biz/UsersService");
};

export class UsersService extends GeneratedBizBase{
  async usersList(): Promise<Response<Users[]>> {
    return super.restCall<Response<Users[]>>('get', '/v1/UsersService/usersList', arguments);
  }
  async getUser(user_id: number): Promise<Response<Users>> {
    return super.restCall<Response<Users>>('get', '/v1/UsersService/getUser', arguments);
  }
  async save_poly_key(user_id: number,poly_key: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/UsersService/save_poly_key', arguments);
  }
  async userEdit(user_id: number,name: string,mail: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/UsersService/userEdit', arguments);
  }
  async changePassword(user_id: number,pass: string,current_pass: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/UsersService/changePassword', arguments);
  }
  async resetPassword(user_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/UsersService/resetPassword', arguments);
  }
  async publishVoucher(user_id: number): Promise<Response<string>> {
    return super.restCall<Response<string>>('post', '/v1/UsersService/publishVoucher', arguments);
  }
  async updatePlan(user_id: number,voucher_code: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/UsersService/updatePlan', arguments);
  }
  async userDel(user_id: number,password: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/UsersService/userDel', arguments);
  }
  async updateTags(user_id: number,tags: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/UsersService/updateTags', arguments);
  }
}
